import * as React from 'react'

import styled from '@emotion/styled'

import { getArcadeLinkStyles } from '../../styles'
import { typography } from '../../theme'
import { ProgressCircular } from '../Arcade/ProgressCircular/ProgressCircular'
import Buttonless from '../Buttonless/Buttonless'
import Text from '../Text/Text'

export type ArcadeLinkButtonProps = {
  ariaLabel: string
  'data-testid'?: string
  isLoading?: boolean
  onClick: () => void
  typography?: keyof Pick<typeof typography, 'linkMedium' | 'linkSmall'>
}

const ButtonLinkContainer = styled(Buttonless)`
  ${props => getArcadeLinkStyles(props.theme)}
  line-height: 0; /* stylelint-disable-line @cash-web/no-hardcoded-font-styles */
  min-height: 0;
  width: fit-content;
`

const ArcadeLinkButton: React.FC<React.PropsWithChildren<ArcadeLinkButtonProps>> = ({
  ariaLabel,
  'data-testid': dataTestId,
  children,
  isLoading,
  onClick,
  typography = 'linkMedium',
}) =>
  isLoading ? (
    <ProgressCircular size="small" />
  ) : (
    <ButtonLinkContainer aria-label={ariaLabel} onClick={onClick} data-testid={dataTestId} type="button">
      <Text typography={typography}>{children}</Text>
    </ButtonLinkContainer>
  )

export default ArcadeLinkButton
